import { NewFormatConditionType, OperatorId } from "types/campaigns";
import { CollectionsConditionValue } from "./CollectionsConditionValue";
import { LabelsArrayConditionValue } from "./LabelsArrayConditionValue";
import { NumberBetweenConditionValue } from "./NumberBetweenConditionValue";
import { NumberConditionValue } from "./NumberConditionValue";
import { TextArrayConditionValue } from "./TextArrayConditionValue";
import { TextConditionValue } from "./TextConditionValue";

interface Props {
  type: `${NewFormatConditionType}`;
  operator: `${OperatorId}`;
  fieldName: string;
}

export const ConditionValue = ({ type, operator, fieldName }: Props) => {
  return (
    <>
      {type &&
        operator &&
        {
          string: {
            eq: <TextConditionValue fieldName={fieldName} />,
            neq: <TextConditionValue fieldName={fieldName} />,
            starts_with: <TextConditionValue fieldName={fieldName} />,
            ends_with: <TextConditionValue fieldName={fieldName} />,
            match: <TextConditionValue fieldName={fieldName} />,
            not_match: <TextConditionValue fieldName={fieldName} />,
            in: <TextArrayConditionValue fieldName={fieldName} />,
            not_in: <TextArrayConditionValue fieldName={fieldName} />,
            in_value_group: <CollectionsConditionValue fieldName={fieldName} />,
            not_in_value_group: (
              <CollectionsConditionValue fieldName={fieldName} />
            ),
          },
          number: {
            eq: <NumberConditionValue fieldName={fieldName} />,
            neq: <NumberConditionValue fieldName={fieldName} />,
            gt: <NumberConditionValue fieldName={fieldName} />,
            gte: <NumberConditionValue fieldName={fieldName} />,
            lt: <NumberConditionValue fieldName={fieldName} />,
            lte: <NumberConditionValue fieldName={fieldName} />,
            in: (
              <TextArrayConditionValue
                fieldName={fieldName}
                valueType="number"
              />
            ),
            not_in: (
              <TextArrayConditionValue
                fieldName={fieldName}
                valueType="number"
              />
            ),
            between: <NumberBetweenConditionValue fieldName={fieldName} />,
            not_between: <NumberBetweenConditionValue fieldName={fieldName} />,
          },
          labelsArray: {
            one_of: <LabelsArrayConditionValue fieldName={fieldName} />,
            not_one_of: <LabelsArrayConditionValue fieldName={fieldName} />,
            one_of_value_group: (
              <CollectionsConditionValue withKeyValue fieldName={fieldName} />
            ),
            not_one_of_value_group: (
              <CollectionsConditionValue withKeyValue fieldName={fieldName} />
            ),
          },
        }[type]?.[operator]}
    </>
  );
};
